var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookAndPencil = function SvgBookAndPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "book-and-pencil_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5.117h43.99V27.74L28.44 47.29v11.592H4zm12.22 12.22h19.55v9.775H16.22zM50.433 32.21 60 41.776 42.893 58.883h-9.566v-9.566z",
    clipRule: "evenodd"
  })));
};
export { SvgBookAndPencil as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgNS4xMTY4Mkg0Ny45OTAyVjI3Ljc0MDdMMjguNDM5IDQ3LjI5MTlWNTguODgyNkg0VjUuMTE2ODJaTTE2LjIxOTUgMTcuMzM2M0gzNS43NzA3VjI3LjExMTlIMTYuMjE5NVYxNy4zMzYzWk01MC40MzQxIDMyLjIwOTZMNjAgNDEuNzc1OEw0Mi44OTI3IDU4Ljg4MzFIMzMuMzI2OFY0OS4zMTY5TDUwLjQzNDEgMzIuMjA5NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";